import {
  emailDailyRecommendationsRedirectEvent,
  emailInstantJobMatchMoreJobsButtonClickedEvent,
  emailInstantJobMatchViewAllButtonClickedEvent,
} from './email'
import footerSearchJobsButtonEvent from './footer'
import { jobPageViewEvent } from './job'
import searchSubmittedEvent from './search'
import { serpFiltersOpenedEvent, serpFiltersUpdatedEvent, serpPageViewEvent } from './serp'

import { miscPageViewEvent, miscSocialMediaLinkClickEvent } from './misc'

export {
  emailDailyRecommendationsRedirectEvent, // Email:daily_recommendations:apply_button:{value}
  emailInstantJobMatchMoreJobsButtonClickedEvent, // Email:instant_job_match:more_jobs_like_this_button
  emailInstantJobMatchViewAllButtonClickedEvent, // Email:daily_recommendations:view_all_button:${value}
  footerSearchJobsButtonEvent, // Footer - Search Button Click
  jobPageViewEvent, // web_job_ad_opened
  miscPageViewEvent, // web_screen_open
  miscSocialMediaLinkClickEvent, // Social Media Link Click
  searchSubmittedEvent, // web_search_button_clicked
  serpFiltersOpenedEvent, // web_filter_open
  serpFiltersUpdatedEvent, // web_filter_changed
  serpPageViewEvent, // web_find_jobs_open
}
